import * as types from '../actions/types';

const initialState = {
    list: {},
    loading: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case types.GET_SEASONS_REQUEST:
            return { ...state, loading: true };
        case types.GET_SEASONS_SUCCESS:
            return { ...state, loading: false, list: action.payload };
        default:
            return state;
    }
}
